import { RuntimeConfig } from 'config/config.types';
import { config as prd } from 'config/envs/pcm-prd';

export const config: RuntimeConfig = {
  ...prd,
  env: 'unknown',
  gravityEnabledByDefault: false,
};
